"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var __baseClass = 'luna-section-header--title';
var classes = {
  base: __baseClass
};
exports.classes = classes;
